import Vue from 'vue';
import newsStatusTransformer from './../../transformers/newsStatus';

const success = ({ data }, resolve) => {
  const newsStatuses = newsStatusTransformer.fetchCollection(data.data);

  resolve(newsStatuses);
};

const failed = () => {
};

// Display bill statuses.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('news_status')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/newsStatus/all.js